import { createApp } from "vue";
import "./assets/scss/styles.scss";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { useMainStore } from "./stores/store";
import vuetify from "@/plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import QrReader from 'vue3-qr-reader';

/************************************************
 * Toast
 ************************************************/
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const pinia = createPinia();

loadFonts();

const app = createApp(App).use(router).use(pinia).use(useMainStore()).use(vuetify).use(QrReader);

app.config.globalProperties.$toast = toast;
app.mount("#app");
